export enum CustomQuoteComponent {
  AmericalSteelCustomQuote = 'AmericalSteelCustomQuote',
  EagleCustomQuote = 'EagleCustomQuote',
  MetalCarportDepotCustomQuote = 'MetalCarportDepotCustomQuote',
}
